var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo/react"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 15.275C14.2564 15.275 15.275 14.2564 15.275 13C15.275 11.7436 14.2564 10.725 13 10.725C11.7436 10.725 10.725 11.7436 10.725 13C10.725 14.2564 11.7436 15.275 13 15.275Z",
    fill: "#149ECA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 17.55C19.2822 17.55 24.375 15.5129 24.375 13C24.375 10.4871 19.2822 8.45 13 8.45C6.71776 8.45 1.625 10.4871 1.625 13C1.625 15.5129 6.71776 17.55 13 17.55Z",
    stroke: "#149ECA",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.05958 15.275C12.2007 20.7156 16.5113 24.1075 18.6875 22.851C20.8637 21.5946 20.0815 16.1656 16.9404 10.725C13.7993 5.28442 9.48873 1.89251 7.3125 3.14896C5.13627 4.40541 5.91846 9.83442 9.05958 15.275Z",
    stroke: "#149ECA",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.05958 10.725C5.91846 16.1656 5.13627 21.5946 7.3125 22.851C9.48873 24.1075 13.7993 20.7156 16.9404 15.275C20.0815 9.83442 20.8637 4.40541 18.6875 3.14896C16.5113 1.89251 12.2007 5.28442 9.05958 10.725Z",
    stroke: "#149ECA",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReact);
export default __webpack_public_path__ + "static/media/logo-react.b04293ab5a2a2ce695720a0ba5d69c58.svg";
export { ForwardRef as ReactComponent };